/**
 * Simple in-memory cache keyed by "lat|lng|date".
 * Entries are invalidated when the date changes (after sunset the key changes).
 */

const cache = new Map();
const MAX_ENTRIES = 60;

/**
 * Build a cache key.
 * @param {number} lat
 * @param {number} lng
 * @param {string} dateKey - ISO date or Hebrew date string
 * @returns {string}
 */
export function cacheKey(lat, lng, dateKey) {
  return `${lat.toFixed(4)}|${lng.toFixed(4)}|${dateKey}`;
}

/**
 * Get cached payload.
 * @param {string} key
 * @returns {object|undefined}
 */
export function getCached(key) {
  return cache.get(key);
}

/**
 * Store payload in cache.
 * @param {string} key
 * @param {object} payload
 */
export function setCached(key, payload) {
  // Evict oldest entries if over limit
  if (cache.size >= MAX_ENTRIES) {
    const firstKey = cache.keys().next().value;
    cache.delete(firstKey);
  }
  cache.set(key, payload);
}

/**
 * Clear the entire cache.
 */
export function clearCache() {
  cache.clear();
}
